import Login from '@/pages/Login'

export default {
  path: '/login',
  name: 'login',
  component: Login
}



// WEBPACK FOOTER //
// ./src/router/login.js